class ConfiguratorBed {
    constructor() {
        this.id = 'bed';
        this.cache = {};
        this.mirror_box = null;
        this.base_has_firmness = false;

        this.selectors = ['size', 'fabric'];
        if (!init_configurators.includes('boxsprings')) {
            this.selectors.push('firmness');
        }

        for (const sel of this.selectors) {
            configurator.addSelectorItem(sel);
        }

        this.init();
    }

    async init() {
        configurator.selection.open = 'open' in configurator.selection ? configurator.selection.open : 1;
        // Hack load Mirror box product
        try {
            const mirror = await (await fetch(storefront_domain + '/products/kungso-mirror-box.json')).json();
            if (mirror) this.mirror_box = mirror.product;
        } catch (e) {
            console.log('No Kungsö mirror box found');
        }
    }

    async refresh() {
        this.populateSizes();
        if (!(configurator.selection.size in this.cache)) {
            await this.loadBuyables(configurator.selection.size);
        }

        this.populateFabrics();

        if (this.selectors.includes('firmness') && configurator.selection.size && configurator.selection.fabric) {
            this.populateFirmnesses();
        }
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector) || ['open', 'linen'].includes(selector);
    }

    setupListeners() {
        if (document.getElementById('show_linen')) {
            document.getElementById('show_linen').addEventListener('change', (e) => {
                delete configurator.selection.linen;
                if (e.currentTarget.checked) {
                    configurator.selection.linen = 1;
                }
                configurator.updateUrlParams();
                configurator.updatePlayer();
            });

            if ('linen' in configurator.selection && configurator.selection.linen == 1) {
                document.getElementById('show_linen').checked = true;
            }
        }

        if (bed_configuration.is_adjustable && document.getElementById('show_open')) {
            document.getElementById('show_open').addEventListener('change', (e) => {
                delete configurator.selection.open;
                if (e.currentTarget.checked) {
                    configurator.selection.open = 1;
                }
                configurator.updateUrlParams();
                configurator.updatePlayer();
            });

            if ('open' in configurator.selection && configurator.selection.open == 1) {
                document.getElementById('show_open').checked = true;
            }
        }
    }

    populateSizes() {
        const items = [];

        for (const size of bed_configuration.sizes) {
            items.push({
                id: size,
                label: size.replace('x', ' x '),
                thumbnail: null,
            });
        }

        if (configurator.selection.size == null) {
            configurator.selection.size = bed_configuration.sizes[0];
        }

        configurator.renderSelector('size', items, {
            columns: 5,
            allow_none: false,
        });
    }

    populateFabrics() {
        const items = [];

        for (const key in configurator.m3_fabrics) {
            if (configurator.m3_fabrics[key][3] != 1) {
                continue;
            }

            // Skip if fabric ID is globally excluded
            // Note: 'key' here is the fabric ID (e.g., "0LINBEI"), not a typical product variant SKU.
            if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(key)) {
                continue;
            }

            const thumbnail = configurator.getSwatch(configurator.m3_fabrics[key][0]);
            const item = {
                id: key,
                label: configurator.m3_fabrics[key][1],
                thumbnail: thumbnail,
                group_by: configurator.m3_fabrics[key][2],
            };

            items.push(item);
        }

        configurator.renderSelector('fabric', items, {
            thumbnails: true,
            allow_none: false,
        });
    }

    populateFirmnesses() {
        // const firmnesses = buyables[ this.selection.size ]['fabrics'][ this.selection.fabric ]['firmnesses'];

        //if (this.selection.fabric == null) { return; }

        //const selector = document.getElementById('firmness'+'_selector');
        //if (!selector) { return; }

        const firmnesses =
            this.cache[configurator.selection.size]['fabrics'][configurator.selection.fabric]['firmnesses'];
        const items = [];
        for (const item in firmnesses) {
            const firm_key = item.replace(/\s/g, '').replace(/,/g, '-');

            items.push({
                id: firm_key.toLowerCase(),
                skus: firmnesses[item].skus,
                ids: firmnesses[item].ids,
                price: firmnesses[item].price,
                label: firmnesses[item].title,
                thumbnail: null,
                available: firmnesses[item].available,
            });
        }

        configurator.renderSelector('firmness', items, {
            columns: 5,
            allow_none: false,
        });
    }

    async loadBuyables(size) {
        const size_arr = size.split('x');
        let is_double = size_arr[0] > 150 ? true : false;
        if (bed_configuration.base.includes("kungsobase") || bed_configuration.base.includes("sandoiconicbaseuk")) { is_double = size_arr[0] > 140 ? true : false; }
        const size_single = is_double ? `${size_arr[0]/2}x${size_arr[1]}` : size;
        
        // Check if this is a Salto bed
        const is_salto_bed = bed_configuration.base.includes('salto');

        const use_base_with_headboard =
            configurator.selection.headboards != null && configurator.selection.headboards != '' && bed_configuration.base_with_headboard != '';

        // Load Bed Base Items
        //key = size + '' + (use_base_with_headboard ? 'h' : '');
        const bases = await configurator.loadProductData(
            'configurator-bed-bases',
            [
                {
                    key: 'category',
                    value: bed_configuration.base,
                },
                { key: 'size', value: is_double && bed_configuration.split_base ? size_single : size },
            ],
            ['fabric'],
        );

        const bases_3sides =
            bed_configuration.base_with_headboard != ''
                ? await configurator.loadProductData(
                      'configurator-bed-bases',
                      [
                          {
                              key: 'category',
                              value: bed_configuration.base_with_headboard
                          },
                          { key: 'size', value: is_double && bed_configuration.split_base ? size_single : size },
                      ],
                      ['fabric'],
                  )
                : null;

        // Load Mattress Items
        // For Salto beds with double size, always use single-sized mattresses
        // For other beds, continue using the bed_configuration.split_mattress flag
        const mattresses =
            bed_configuration.mattress != ''
                ? await configurator.loadProductData(
                      'configurator-mattresses',
                      [
                          { key: 'category', value: bed_configuration.mattress },
                          {
                              key: 'size',
                              value:
                                  is_salto_bed && is_double
                                      ? size_single
                                      : bed_configuration.split_mattress
                                        ? size_single
                                        : size,
                          },
                      ],
                      ['fabric'],
                  )
                : [];
        this.base_has_firmness = mattresses.length == 0 && bed_configuration.type != 'bedframe'; // Firmness is in separate mattress (Except for Rörö, Hällsö)

        this.cache[size] = { title: size, fabrics: {} };
        this.cache[size + '_3s'] = { title: size, fabrics: {} };

        if (this.base_has_firmness) {
            const x2 = is_double && bed_configuration.split_base;
            this.populateItemsWithFirmness(size, bases, x2);
            if (bases_3sides) {
                this.populateItemsWithFirmness(size + '_3s', bases_3sides, x2);
            }
        } else {
            const x2 = is_double && bed_configuration.split_base;
            this.populateItems(size, bases, x2);
            if (bases_3sides) {
                this.populateItems(size + '_3s', bases_3sides, x2);
            }
        }

        if (mattresses.length > 0) {
            // For Salto beds with double size, always use split mattresses
            // For other beds, continue using the bed_configuration.split_mattress flag
            const x2 = is_double && (is_salto_bed || bed_configuration.split_mattress);
            this.populateItemsWithFirmness(size, mattresses, x2);
            if (bases_3sides) {
                this.populateItemsWithFirmness(size + '_3s', mattresses, x2);
            }
        }
    }

    populateItems(key, items, split) {
        for (const product of items) {
            for (const variant of product.variants) {
                if (variant.price == 0 && configurator.enable_ecommerce == true) {
                    continue;
                }

                // Skip if SKU is globally excluded
                if (
                    bed_configuration.excluded_skus_global_set &&
                    bed_configuration.excluded_skus_global_set.has(variant.sku)
                ) {
                    console.log(
                        `Bed (base/mattress) SKU ${variant.sku} for product ${product.productid} fabric ${product.fabric} excluded globally in populateItems.`,
                    );
                    continue;
                }

                // Add a SKU for base
                const variant_id = variant.id.replace('gid://shopify/ProductVariant/', '');

                this.cache[key]['fabrics'][product.fabric] = {
                    title: product.fabric,
                    ids: split ? [variant_id, variant_id] : [variant_id],
                    price: (split ? 2 : 1) * variant.price,
                    skus: split ? [variant.sku, variant.sku] : [variant.sku],
                    available: variant.availableForSale,
                    firmnesses: {},
                };
            }
        }
    }

    populateItemsWithFirmness(key, items, split) {
        for (const product of items) {
            if (!(product.fabric in this.cache[key]['fabrics'])) {
                //if (!add_new) { continue; } // No base found

                this.cache[key]['fabrics'][product.fabric] = {
                    title: product.fabric,
                    firmnesses: {},
                };
            }

            for (const variant of product.variants) {
                if (variant.price == 0 && configurator.enable_ecommerce == true) {
                    continue;
                }

                // Skip if SKU is globally excluded
                if (
                    bed_configuration.excluded_skus_global_set &&
                    bed_configuration.excluded_skus_global_set.has(variant.sku)
                ) {
                    console.log(
                        `Bed (base/mattress) SKU ${variant.sku} for product ${product.productid} fabric ${product.fabric} excluded globally in populateItemsWithFirmness.`,
                    );
                    continue;
                }

                // Add base and mattress firmness at once
                const variant_id = variant.id.replace('gid://shopify/ProductVariant/', '');
                const firm_key = variant.title.toLowerCase().replace(/\s/g, '').replace(/,/g, '-');
                this.cache[key]['fabrics'][product.fabric]['firmnesses'][firm_key] = {
                    title: variant.title,
                    ids: [variant_id],
                    price: variant.price,
                    skus: [variant.sku],
                    available: variant.availableForSale,
                };
            }

            if (split) {
                // Generate cross combinations
                this.cache[key]['fabrics'][product.fabric]['firmnesses'] = configurator.buildFirmnessCrossCombinations(
                    this.cache[key]['fabrics'][product.fabric]['firmnesses'],
                );
            }
        }
    }

    isSoldOut() {
        return false;
    }

    getPriceData(priceData) {
        //data.buyables[size]
        // Get base product
        const base_fabric = bed_configuration.is_wallnut ? '0WALN' : configurator.selection.fabric;
        const cacheKey =  configurator.selection.headboards == null || bed_configuration.base_with_headboard == '' ? configurator.selection.size : configurator.selection.size + '_3s';
        if (!(base_fabric in this.cache[cacheKey].fabrics)) {
            // No base found?
            return;
        }

        // Load base with specific fabric
        if (!this.base_has_firmness) {
            const item = this.cache[cacheKey].fabrics[base_fabric];
            const price = item.price ?? 0; //!= undefined ? item.price : 0;
            console.log('base' + ' => ' + item.ids.join(',') + ' => ' + price);
            priceData.total += price;
            if (item.skus.length > 0) {
                priceData.skus.push(...item.skus);
            }
            if (item.ids.length > 0) {
                priceData.ids.push(...item.ids);
            }
        }

        if (
            configurator.selection.firmness != null &&
            configurator.selection.firmness in this.cache[cacheKey].fabrics[base_fabric].firmnesses
        ) {
            const item =
                this.cache[cacheKey].fabrics[base_fabric].firmnesses[
                    configurator.selection.firmness
                ];
            const price = item.price ?? 0; //!= undefined ? item.price : 0;
            console.log('mattress' + ' => ' + item.ids.join(',') + ' => ' + price);
            priceData.total += price;
            if (item.skus.length > 0) {
                priceData.skus.push(...item.skus);
            }
            if (item.ids.length > 0) {
                priceData.ids.push(...item.ids);
            }
        }

        if ((bed_configuration.base.includes("kungsobase") || bed_configuration.base.includes("sandoiconicbaseuk") || bed_configuration.base.includes("sandoiconicbase")) && this.mirror_box) {
            // Hack: Add Mirror Box to order 
            const size_arr = configurator.selection.size.split('x');
            const mirror_size = size_arr[0] > 180 ? '120x110' : '90x110';
            const variant = this.mirror_box.variants.filter((v) => v.option1 == mirror_size).pop();
            console.log('Mirror box (' + variant.option1 + ') => ' + variant.id + ' => ' + variant.price);

            priceData.total += parseFloat(variant.price);
            priceData.skus.push(variant.sku);
            priceData.ids.push(variant.id);
        }
    }

    getCylindoSpecs(specs) {
        // ============== Load appropriate bed model size ==============
        // Beds only
        let model_size = '180';
        if (configurator.selection.size && typeof bed_configuration.cylindo_model == 'object') {
            const size_arr = configurator.selection.size.split('x');

            if (['80', '90', '105'].includes(size_arr[0])) {
                model_size = '90';
            }
            if (['120', '135', '140', '150'].includes(size_arr[0])) {
                model_size = '140';
            }
            if (['160', '180', '200', '210'].includes(size_arr[0])) {
                model_size = '180';
            }

            specs.code = bed_configuration.cylindo_model[model_size];
        }

        // ============== Translate "Show elevated" config ==============
        specs.code = specs.code.replace('_OPEN', '').replace('_CLOSED', '');
        if (bed_configuration.is_adjustable) {
            specs.code += configurator.selection.open == 1 ? '_OPEN' : '_CLOSED';
        }
        /*
        Curated Viewer..

        if (bed_configuration.product != null && model_size == '180'
                && bed_configuration.product != this.viewer.getAttribute("remote-config")) {
                    this.viewer.setAttribute("remote-config", bed_configuration.product);
        } else {
            this.viewer.removeAttribute("remote-config");
        }
*/
        // ============== Translate Fabric config ==============
        if (configurator.selection.fabric != null) {
            specs.features.UPHOLSTERY = configurator.m3_fabrics[configurator.selection.fabric][0];
        }

        // ============== Translate "Show linen" config ==============
        if (configurator.selection.linen == 1) {
            specs.features['BEDDING'] = 'ON';
        }
    }
}
